import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import {GalleryComponent} from './gallery/gallery.component'
const routes: Routes = [
    { path: '',             component: HomeComponent },
    { path: 'gallery/:name',             component: GalleryComponent },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts